import React from 'react';
import { Box, Typography, Link, IconButton, Tooltip } from '@mui/material';
import FeedbackIcon from '@mui/icons-material/Feedback';

export const FOOTER_HEIGHT_PX = 72; // keep in sync with your composer math

export default function Footer({ darkMode }) {
  return (
    <Box
      component="footer"
      sx={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        height: FOOTER_HEIGHT_PX,
        px: .5,
        py: .5,
        borderTop: (t) => `1px solid ${t.palette.divider}`,
        bgcolor: darkMode ? '#0e0e0e' : '#fafafa',
        color: darkMode ? '#e0e0e0' : '#333',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 1,
        zIndex: (t) => t.zIndex.drawer + 2,  // above main content
        // subtle glassy feel (optional)
        backdropFilter: 'saturate(1.1) blur(6px)',
        WebkitBackdropFilter: 'saturate(1.1) blur(6px)',
      }}
    >
      <Typography variant="body2" sx={{ mr: 1 }}>
        © {new Date().getFullYear()} XFactual — Designed by{' '}
        <Link href="https://mypenmail.com" target="_blank" rel="noreferrer" underline="hover">
          mypenmail.com
        </Link>
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography variant="body2">
          Reach us at{' '}
          <Link href="mailto:sales@mypenmail.com" underline="hover">
            sales@mypenmail.com
          </Link>
        </Typography>

        <Tooltip title="Suggest a feature">
          <IconButton
            size="small"
            component={Link}
            href="mailto:admin@mypenmail.com?subject=XFactual%20Feature%20Suggestion"
            sx={{ color: 'inherit' }}
          >
            <FeedbackIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
}

/** Spacer to prevent overlap when needed on pages that don't already
 *  reserve space with bottom gaps. Drop <FooterSpacer /> near the end
 *  of your page if content gets covered.
 */
export function FooterSpacer() {
  return <Box sx={{ height: FOOTER_HEIGHT_PX }} />;
}

